import React from "react"
import styled from "styled-components"
import {injectIntl} from "@irati/utils/lang"
import {Body, Label} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {EditableBudget} from "../hooks"
import ColorIcon from "../../../components/Budgeting/ColorIcon"
import {Row, Item} from "./EditableRow"
import {AmountInput} from "./AmountInput"

const StyledLabel = styled(Label)`
  font-size: 10px;
  line-height: 12px;
`

interface Props {
  max: number
  min: number
}

export const ManagerBudget = injectIntl<Props & EditableBudget>(({formatMessage, ...category}) => {
  const {uuid, metadata, name, tag} = category
  const {colors} = useTheme()

  return (
    <Row simple key={uuid}>
      <Item area="icon">
        <ColorIcon color={metadata.color} size={40} />
      </Item>

      <Item area="name" direction="column">
        <Body small>{name}</Body>
        {tag && <StyledLabel color={colors.greys.mediumDark}>{tag.name}</StyledLabel>}
      </Item>

      <Item area="amount">
        <AmountInput {...category} formatMessage={formatMessage} />
      </Item>
    </Row>
  )
})
